<template>
  <v-navigation-drawer app class="side-menu" clipped expand-on-hover permanent width="300">
    <v-layout class="primary-text" column fill-height>
      <v-list v-if="getExternalBIMenus.length" nav>
        <template v-for="menu in getExternalBIMenus">
          <v-list-group v-if="menu.reports.length" :key="menu.id" :group="`exbi-${menu.id}`" no-action>
            <template v-slot:activator>
              <v-list-item-icon v-if="menu.icon">
                <mf-icon fill>{{ menu.icon }}</mf-icon>
              </v-list-item-icon>
              <v-list-item-content class="px-0">
                <v-list-item-title class="body-2">{{ menu.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="report in menu.reports" :key="report.id" :to="`/external-bi/${report.route}`">
              <v-list-item-icon v-if="report.icon">
                <mf-icon fill>{{ report.icon }}</mf-icon>
              </v-list-item-icon>
              <v-list-item-content class="body-2">{{ report.name }}</v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { useStore as mainUseStore } from '@/store'

export default {
  name: 'SideMenu',
  computed: {
    getExternalBIMenus() {
      return mainUseStore().getExternalBIMenus
    },
  },
}
</script>
<style lang="scss">
.side-menu {
  z-index: 10;
}

.bottom-feedback-box {
  position: absolute;
  background-color: $branco;
  bottom: 0;
  width: 250px;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
  margin: 0 !important;
}

.v-list-group .v-list-item--active {
  .mf-icon {
    color: $marca-0 !important;
  }
}
</style>
